import { isGdprCountry } from '@change-corgi/config/countries';

import type { GdprConfig } from 'src/app/pages/petitionDetails/shared/hooks';

export function isGdprEnabled(countryCode: string | undefined, gdprConfig: GdprConfig): boolean {
	return gdprConfig.enabled && !!countryCode && isGdprCountry(countryCode);
}
